export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-6 order-2 md:order-1">
            <p className="overline mb-4">About Aroha Homes</p>
            <h2 className="font-display text-4xl sm:text-5xl text-foreground font-medium leading-[1.05] tracking-tight">
              A home in the hills, run by people who actually live here.
            </h2>
            <div className="mt-8 space-y-5 font-sans text-base text-foreground/85 leading-relaxed max-w-xl">
              <p>
                Aroha Homes sits high in Madikeri, the misty heart of Coorg, surrounded by coffee
                plantations and the dense canopy of the Western Ghats. We're a family-run homestay —
                spacious enough for big groups, intimate enough for honeymooners.
              </p>
              <p>
                Wake up to fog rolling through the valley, drive 20 minutes to Abbey Falls or
                Mandalpatti, return to a slow evening with a bonfire, homemade pandi curry and
                kadumbuttu. That's an Aroha day.
              </p>
            </div>
          </div>
          <div className="md:col-span-6 order-1 md:order-2">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.unsplash.com/photo-1633437805600-2c58bf56663c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                alt="Coffee plantation in Coorg"
                className="rounded-2xl aspect-[3/4] object-cover col-span-1 row-span-2"
                loading="lazy"
              />
              <img
                src="https://images.unsplash.com/photo-1601134917279-ef70a0a90f18?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                alt="Tents under the stars"
                className="rounded-2xl aspect-[4/3] object-cover"
                loading="lazy"
              />
              <img
                src="https://images.unsplash.com/photo-1625398407796-82650a8c135f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                alt="Coorg-style food"
                className="rounded-2xl aspect-[4/3] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
